
import { common } from '@tencent/ceiba-base-components';
import { saveRoleToCookie } from '@tencent/upweb-utils';
const openUrl = (url, target = '_self') => {
  try {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      window.location.href = url;
      return;
    }
    const newTab = window.open('', target);
    newTab.opener = null;
    newTab.location = url;
  } catch (error) {
    console.error('openUrl fail, err=', error);
    window.location.href = url;
  }
};

function getLoginStatusUrl(url, store, type = '') {
  const { roleInfo = {}, userInfo = {} } = store;
  const accType = common.tool.getCookie('acctype') || '';
  const openId = common.tool.getCookie('openid') || '';
  const appId = common.tool.getCookie('appid') || '';
  const accessToken = common.tool.getCookie('access_token') || '';
  const formUrl = encodeURIComponent(window.location.href);

  let params = {};

  switch (type) {
    // 尊享商城，大商城
    case 'zunxiangToken':
    case 'dashangchengToken':
      params = {
        scpOpenId: openId,
        scpToken: accessToken,
        scpAppId: appId,
        scpAccType: accType,
        from: formUrl,
      };
      if (roleInfo && roleInfo.role_id) {
        Object.assign(params, {
          scpRoleId: roleInfo.role_id,
          scpAreaId: roleInfo.area_id,
          scpPartitionId: roleInfo.partition_id,
          scpPlatId: roleInfo.plat_id,
          scpRoleName: encodeURIComponent(common.tool.Base64.decode(roleInfo.role_name)),
          scpPartitionName: encodeURIComponent(common.tool.Base64.decode(roleInfo.partition_name)),
        });
      }
      break;
      // 直播间
    case 'liveStudioToken':
      params = {
        openid: openId,
        access_token: accessToken,
        appid: appId,
        acctype: accType,
        nickname: encodeURIComponent(userInfo.nickName),
        avatar: encodeURIComponent(userInfo.avatar),
        from: formUrl,
      };
      if (roleInfo && roleInfo.role_id) {
        Object.assign(params, {
          game_open_id: roleInfo.game_open_id,
          game_app_id: roleInfo.game_app_id,
          area_id: roleInfo.area_id,
          plat_id: roleInfo.plat_id,
          partition_id: roleInfo.partition_id,
          role_id: roleInfo.role_id,
          role_name: encodeURIComponent(common.tool.Base64.decode(roleInfo.role_name)),
          partition_name: encodeURIComponent(common.tool.Base64.decode(roleInfo.partition_name)),
          device: roleInfo.device,
        });
      }
      break;
      // 无忧充值
    case 'worryFreeChargeToken':
      params = {
        appid: appId,
        openid: openId,
        acctype: accType,
        access_token: accessToken,
        from: formUrl,
      };
      break;
    default:
      break;
  }
  console.log('getLoginStatusUrl params=', params);
  const queryStrings = [];
  Object.keys(params).forEach((key) => {
    const value = params[key];
    queryStrings.push(`${key}=${value}`);
  });
  const queryPath = `${url}${url.includes('?') ? '&' : '?'
  }${queryStrings.join('&')}`;
  console.log('getLoginStatusUrl queryPath=', queryPath);

  return queryPath;
}

const openerPlugin = {
  install(Vue) {
    Vue.prototype.$openerSupercorePlugin = {
      getOpenViewSchema: async (params) => {
        console.log('supercore getOpenViewSchema=', params);
        return [
          {
            key: 'needLogin',
            name: '校验登录',
            type: 'select',
            default: 0,
            options: [
              {
                label: '无需登录也可跳转',
                value: 0,
              },
              {
                label: '登录后方可跳转',
                value: 1,
              },
            ],
            hidden: false,
          },
          {
            key: 'loginToken',
            name: '携带登录态',
            type: 'select',
            default: '',
            options: [
              {
                label: '无',
                value: '',
              },
              {
                label: '尊享商城登录态',
                value: 'zunxiangToken',
              },
              {
                label: '大商城登录态',
                value: 'dashangchengToken',
              },
              {
                label: '直播间登录态',
                value: 'liveStudioToken',
              },
              {
                label: '无忧充值登录态',
                value: 'worryFreeChargeToken',
              },
            ],
            hidden: context => context.payload.needLogin !== 1,
          },
        ];
      },
      openView: async (params, store) => {
        const payload = params.payload || {};
        let toLink;
        // 拿到配置是否登录的状态
        if (payload.needLogin === 1) {
          // 用户登录成功用户信息不为空对象即登录状态
          console.log('needLogin, isLogin=', store.isLogin, store.roleInfo);
          if (store.isLogin) {
            // 在用户登录情况下，当需要携带登录态跳转时
            if (payload.loginToken === 'zunxiangToken') {
              toLink = getLoginStatusUrl(params.url, store, 'zunxiangToken');
            } else if (payload.loginToken === 'dashangchengToken') {
              toLink = getLoginStatusUrl(params.url, store, 'dashangchengToken');
              console.log('dashangchengToken====大商城登录态cdn引入成功');
              const domainOne = params.url.split('//')[1]?.split('/')[0]; // 截取一级域名
              const loginStatus = Vue.prototype.$miloCore?.loginStatus || window.milo.loginStatus;
              console.log('upWebUtils===', domainOne, params.url, loginStatus, store.actInfo.gid, toLink);
              await new Promise((resolve) => {
                saveRoleToCookie(store.actInfo.gid, store.roleInfo, {
                  loginStatus, // milo loginStatus结构体
                  handler: loginStatus.syncToQQ,
                  domain: domainOne, // 需要同步的域名
                }).then((key) => {
                  console.log(key);
                  console.log(document.cookie);
                  toLink = `${toLink}${toLink.includes('?') ? '&' : '?'}upRoleKey=${key}`;
                  console.log('saveRoleToCookie success', key, toLink);
                  resolve();
                })
                  .catch((e) => {
                    console.log('saveRoleToCookie error', e);
                    // toLink = params.url;
                    toLink = getLoginStatusUrl(params.url, store, 'dashangchengToken');
                    resolve();
                  });
              });
            } else if (payload.loginToken === 'liveStudioToken') {
              toLink = getLoginStatusUrl(params.url, store, 'liveStudioToken');
            } else if (payload.loginToken === 'worryFreeChargeToken') {
              toLink = getLoginStatusUrl(params.url, store, 'worryFreeChargeToken');
            } else {
              // 在用户登录情况下，不需要携带登录态跳转时
              toLink = params.url;
            }
          } else {
            Vue.prototype.alert('请登录后进行操作');
            return;
          }
        } else {
          toLink = params.url;
        }
        console.log('toLink=', toLink);
        openUrl(toLink, params.target);
      },
    };
  },
};

export default openerPlugin;
